export {NewCandidate} from './NewCandidate';
